import { RootState } from '../../reducers'

export const documentHistorySelector = (state: RootState) => state.ui.bottomPanelDocumentHistory

export const isDocumentHistoryPanelOpenSelector = (state: RootState) =>
  documentHistorySelector(state) === null
